import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { PATH, makePath } from 'shared';
import Layout from './Layout';
import * as Views from './views';
const propTypes = {};
const defaultProps = {};
function Routes() {
    const { path } = useRouteMatch();
    return (_jsx(Layout, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: path, children: _jsx(Views.Applicants, {}) }), _jsx(Route, { path: makePath(path, PATH.CONTINUE_APPLICATION), children: _jsx(Views.ContinuedCreditApplication, {}) }), _jsx(Route, { path: makePath(path, PATH.NEW_ACCESS_LOAN), children: _jsx(Views.NewAccessLoan, {}) }), _jsx(Route, { path: makePath(path, PATH.PUSH_APPLICATION), children: _jsx(Views.PushApplication, {}) }), _jsx(Redirect, { path: "*", to: makePath(path, PATH.CREDIT_APPLICATION) })] }) }));
}
Routes.propTypes = propTypes;
Routes.defaultProps = defaultProps;
export default Routes;
